import { useHistory } from 'cross-platform/react-router';

type Props = {
  history: ReturnType<typeof useHistory>;
  productReference: string;
};
const createActions = (_props: Props): undefined => {
  return undefined;
};

export { createActions };
